import { render, staticRenderFns } from "./scene1.vue?vue&type=template&id=33bf5716&scoped=true&"
import script from "./scene1.vue?vue&type=script&lang=ts&"
export * from "./scene1.vue?vue&type=script&lang=ts&"
import style0 from "./scene1.vue?vue&type=style&index=0&id=33bf5716&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf5716",
  null
  
)

export default component.exports